// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__2YUis","footer":"ModalInfo_footer__1wLha"};